"use client";
import React, { useEffect } from "react";
import dynamic from 'next/dynamic';
const Header = dynamic(() => import('@/Component/Header'), { ssr: false });
const Footer = dynamic(() => import('@/Component/Footer'), { ssr: false });
const TitleText = dynamic(() => import('@/Component/TitleText'), { ssr: false });
import styles from "./ServiceCenterPage.module.css";
import { useTranslation } from "react-i18next";
import arrow_icon from "@/assets/Icon/Scroll_Icon.png"
import { OnOpenUrl,OnPreFetchUrl } from "@/Component/accordion";
import { useRouter} from "next/navigation"
import Image from "next/image";
const ServiceCenterPage = () => {
        const router = useRouter();
    const {t} = useTranslation();
    useEffect(()=>{
        OnPreFetchUrl({content : {url : "service/question"}, navigate : router})
    },[]);
    return (
        <div className={styles.service__center}>
            <Header></Header>
            <TitleText titleTextInfo={{textKey : "Footer.CustomerCenter"}}></TitleText>
            <div className={styles.service__center__container}>
                <div className={styles.service__center__content}>
                    <div className={styles.title__content}>
                        <span className={styles.title__Guide__text}>
                            {t("ServiceCenter.Email.Guide")}
                        </span>
                    </div>

                    <div className={styles.contact__list}>
                        <span className={styles.title__text}>
                            {t("ServiceCenter.Email.Title")}
                        </span>

                        <a href='mailto:contact@bepex.xyz' className={styles.contact__list__description}>
                            {t("ServiceCenter.Email.Address")}
                        </a>
                    </div>

                    <div className={styles.email__ex}>
                        <span className={styles.title__text}>
                            {t("ServiceCenter.Email.Example.Title")}
                        </span>
                        <div className={styles.email__ex__list}>
                            <span >
                                {t("ServiceCenter.Email.Example.Game")}
                            </span>
                            <span >
                            {t("ServiceCenter.Email.Example.Crash")}

                            </span>
                            <span >
                            {t("ServiceCenter.Email.Example.Payment")}
                            </span>
                        </div>
                    </div>

                    <div className={styles.frequently__asked__questions} onClick={() =>OnOpenUrl({content : {url : "service/question"}, navigate : router}) }>
                        <span className={styles.title__text}>
                            {t("ServiceCenter.FAQ.Link")}
                        </span>
                        <div className={styles.apply__btn}>
                            <Image src={arrow_icon} className={styles.apply__btn__image} alt="view"/>
                        </div>
                    </div>   

                    <div className={styles.notice}>
                        <span >
                            {t("ServiceCenter.Email.Note")}
                        </span>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default ServiceCenterPage;